import { atomWithStorage } from "jotai/utils";
import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";

export const portfolioCollapsedSectionsState = atomWithStorage<
	PortfolioCategoryId[]
>("MYPLANN_PORTFOLIO_COLLAPSED_SECTIONS", []);
